module.exports = __webpack_public_path__ + "static/img/plane.071ad6b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/plane.gif
// module id = y4sZ
// module chunks = 1